import Quill from 'quill'
import { InternalError } from './error'
import Helper from './helper'
import Is from './is'
import type { Type } from '../type'

export default class Ui
{
	static init():void
	{
		Ui.load('date-picker')
		Ui.load('time-picker')
		Ui.load('select-picker')
		Ui.load('input-file')
		Ui.load('input-file-image')
		Ui.load('text-editor')

		Ui.load('text-truncate')
		Ui.load('text-tooltip')

		Ui.load('table-sorter')
		Ui.load('table-link-cell')
		Ui.load('table-filter')
		Ui.load('table-sticky-header')

		Ui.load('image-gallery')
	}

	protected static readonly _dismiss_second = 10

	static notify(type:'notice'|'warning'|'error', message:string):void
	{
		const parameter = {
			type         : 'danger',
			allow_dismiss: true,
			delay        : null as number|null,
		}

		switch(type)
		{
			case 'notice':
				parameter.type = 'success'
				parameter.allow_dismiss = false
				parameter.delay = Ui._dismiss_second * Helper.unit.millisecond
			break

			case 'warning':
				parameter.type = 'warning'
				parameter.allow_dismiss = false
				parameter.delay = Ui._dismiss_second * Helper.unit.millisecond
			break
		}

		$.notify({message: message}, parameter)
	}

	protected static _indicator:HTMLDivElement|null = null

	static indicator(on:boolean):void
	{
		if(this._indicator === null)
		{
			this._indicator = document.createElement('div')
			this._indicator.className = 'loader loader-bouncing'

			document.body.appendChild(this._indicator)
		}

		if(on) $(this._indicator).addClass('is-active')
		else $(this._indicator).removeClass('is-active')
	}

	static reload(timeout = 3):void
	{
		setTimeout(() => location.reload(), timeout * Helper.unit.millisecond)
	}

	static confirm(type:'submit'|'execute'|'remove'|'logout'):boolean
	{
		let message:string|undefined = undefined

		switch(type)
		{
			case 'submit' :
				message = '更新しますか？'
			break

			case 'execute' :
				message = '実行しますか？'
			break

			case 'remove' :
				message = '削除しますか？'
			break

			case 'logout' :
				message = 'ログアウトしますか？'
			break
		}

		if(message === undefined) throw new InternalError(`不正なメッセージ種別です`)
		return confirm(message)
	}

	static post(url:string, data:Type.hash, callback?:Function, timeout_second = 10):void
	{
		(async() =>
		{
			const result = {
				message: '(メッセージが指定されていません)',
				success: false,
			}

			try
			{
				const response = await $.ajax({
					method : 'POST',
					url    : url,
					data   : data,
					timeout: timeout_second * Helper.unit.millisecond,
				})

				result.success = response.success
				if(!response.success) throw new InternalError(response.message || result.message)

				result.message = response.message
			}
			catch(exception)
			{
				switch(exception.statusText)
				{
					case 'timeout' :
						result.message = '処理がタイムアウトしました'
					break

					default :
						result.message = exception.message || exception.statusText
						if(result.message === 'error') result.message = 'エラーが発生しました'
					break
				}

				result.success = false
			}
			finally
			{
				if(result.message !== null) Ui.notify(result.success ? 'notice' : 'error', result.message)
				if(callback !== undefined) callback(result.success, result.message)
			}
		})()
	}

	static flip_password(selector:string):void
	{
		const type = $(selector).attr('type')
		$(selector).attr('type', type === 'password' ? 'text' : 'password')
	}

	static load(type:string):void
	{
		switch(type)
		{
			case 'table-sticky-header' :
				$('.ui-table-sticky-header').floatThead()
			break

			case 'table-sorter' :
				$('.ui-table-sorter').tablesorter({
					sortList        : [[0, 1]],
					sortInitialOrder: 'desc',

					textExtraction: (node:string) =>
					{
						const value = $(node).attr('data-sort')
						return typeof value !== 'undefined' ? value : $(node).text()
					},
				})
			break

			case 'table-link-cell' :
				$('table.ui-table-link-cell tbody tr').each((index, row) =>
				{
					const link = $(row).attr('data-href')
					if(!link) return

					const row_element = $(row)

					row_element.find('> td:not(.no-link)').each((index2, cell) =>
					{
						if(cell.firstChild && cell.firstChild.nodeName === 'A')
						{
							(cell.firstChild as HTMLAnchorElement).style.display = 'inline-block'
							return
						}

						const cell_element = $(cell)
						const anchor = document.createElement('a')

						anchor.href = link
						anchor.className = 'link-anchor'

						if(cell_element.html().match(/^\s*$/)) cell_element.html('&nbsp;')
						cell_element.css('padding', '0')

						cell_element.contents().appendTo(anchor)
						$(anchor).appendTo(cell_element)
					})
				})

				$('table.ui-table-link-cell').css('display', 'table')
			break

			case 'table-filter' :
				window.LightTableFilter.init()
			break

			case 'date-picker' :
				$('input.ui-date-picker').each((index, element) =>
				{
					$(element).datepicker({
						language  : 'ja',
						autoClose : true,
						dateFormat: 'yyyy-mm-dd',
						timeFormat: 'hh:ii AA',
						firstDay  : 0,
					})

					const value = $(element).val() as string
					if(value) $(element).data('datepicker').selectDate(new Date(value))
				})
			break

			case 'time-picker' :
				$('.ui-time-picker').timepicker({
					snapToStep: true,
					minuteStep: 5,
					showMeridian: false,
					defaultTime: false,
					icons: {
						up: 'fa fa-icon fa-chevron-up',
						down: 'fa fa-icon fa-chevron-down'
					}
				})
			break

			case 'select-picker' :
				$('select').selectpicker({
					liveSearch      : true,
					size            : 10,
					dropupAuto      : false,
					noneSelectedText: '(未選択)',
					noneResultsText : '{0}の該当はありません',
				})
			break

			case 'input-file' :
				$('input[type="file"]:not([class="ui-input-file-image"])').filestyle({
					text        : ' 選択',
					btnClass    : 'btn-primary',
					badge       : true,
					buttonBefore: true,
				})
			break

			case 'input-file-image' :
				const input_image = $('input[type="file"].ui-input-file-image')

				input_image.filestyle({
					text : '画像選択',
					badge: true,
					input: false,
				})

				input_image.each((index, input) =>
				{
					const preview = $(input).data('preview')
					if(!Is.filled(preview)) return

					const tag = document.querySelector(preview)
					if(!tag) return

					const original = tag.src

					input.addEventListener('change', function()
					{
						//@ts-ignore
						tag.src = this.files.length > 0 ? URL.createObjectURL(this.files[0]) : original
						if(!String(input.getAttribute('accept')).match(/^video\//)) tag.parentNode.href = tag.src
					})
				})
			break

			case 'text-editor' :
				if($('.ui-text-editor').length > 0)
				{
					new Quill('.ui-text-editor', {
						modules: {
							toolbar: [
								[{'header': 1}, {'header': 2}, 'bold'],
								[{'list': 'ordered'}, {'list': 'bullet'}],
								['link'],
							],
						},
						theme  : 'snow',
					})

					$('.ui-text-editor').css('display', 'block')
				}
			break

			case 'text-truncate' :
				$('.text-truncate').on('mouseenter', function()
				{
					const element = $(this)

					if(this.offsetWidth < this.scrollWidth)
					{
						element.tooltip({
							title: element.text(),
						})

						element.tooltip('show')
					}
				})
			break

			case 'text-tooltip' :
				$('.ui-text-tooltip').tooltip()
			break

			case 'image-gallery' :
				$('.ui-image-gallery').magnificPopup({
					type     : 'image',
					zoom     : {
						enabled: true,
						easing  : 'ease-in-out',
					},
					gallery: {
						enabled: true,
						tPrev: '前',
						tNext: '次',
						tCounter: '%curr% / %total%',
						preload: [1, 1],
					},
					image  : {
						titleSrc: 'title',
						tError: '画像がありません',
					},
				})

				$('.ui-image-gallery').on('mouseenter', (event) =>
				{
					document.createElement('img').src = (event.currentTarget as HTMLAnchorElement).href
				})
			break
		}
	}

	static is_mobile():boolean
	{
		return window.matchMedia('only screen and (max-width: 767px)').matches
	}
}
